export function hasAdapterMultilingualData(adapter, data) {
    var _a;
    return Boolean((_a = adapter === null || adapter === void 0 ? void 0 : adapter.hasMultilingual) === null || _a === void 0 ? void 0 : _a.call(adapter, data));
}
